import { render, staticRenderFns } from "./delegateDetails.vue?vue&type=template&id=5087cbda&scoped=true"
import script from "./delegateDetails.vue?vue&type=script&lang=js"
export * from "./delegateDetails.vue?vue&type=script&lang=js"
import style0 from "./delegateDetails.vue?vue&type=style&index=0&id=5087cbda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087cbda",
  null
  
)

export default component.exports